import assign from '@ali/xutil/assign';
import gatewaySettings from '../common/qianniu-gateway-settings';

export default (X) => {

  let gateway = {

    setup: gatewaySettings.setup,

    invoke(options) {
      // To support api alias, we need to get api info from api map.
      let api = X.getApiByAlias(options.api);
      let {query, settings} = options;
      query = query || {};
      settings = settings || {};
      settings = assign.deep({}, gatewaySettings.get(), settings);

      options.api =  api || {
        type: X.API_TYPE.QN_GATEWAY,
        uri: options.api,
      };

      /**
       * `response_style` 优先级：
       * 1. 用户 `options.query.response_style`
       * 2. 用户 `options.settings.response_style`
       * 3. `gatewaySettings.response_style`
       */
      if (!query.hasOwnProperty('response_style')) {
        query.response_style = settings.response_style;
      }
      if (query.response_style !== 'h5_style') {
        delete query.response_style;
      }

      return X.call(options);
    },
  };

  return gateway;
}



// WEBPACK FOOTER //
// ./src/plugins/qianniu-pc-gateway-by-native.js